import type { Editor } from "@tiptap/core";

// Heading levels the minimal-headings editor variant flattens to render like
// bolded paragraphs (see .ProseMirror-minimal-headings in global.css). h4 is
// not flattened and keeps normal bold toggling.
const MINIMAL_HEADING_LEVELS = [1, 2, 3];

export const isMinimalHeadingActive = (editor: Editor): boolean =>
  MINIMAL_HEADING_LEVELS.some((level) => editor.isActive("heading", { level }));

// Unbolding a flattened heading must clear bold marks across the entire
// heading block, not just the caret position: a collapsed-selection
// unsetBold only clears stored marks, which would leave existing
// <strong> content bold after the block becomes a paragraph.
export const unboldMinimalHeading = (editor: Editor): boolean =>
  editor
    .chain()
    .focus()
    .command(({ state, tr }) => {
      const { from, to } = state.selection;
      state.doc.nodesBetween(from, to, (node, pos) => {
        if (node.type.name !== "heading") return true;
        tr.removeMark(pos, pos + node.nodeSize, state.schema.marks.bold);
        return false;
      });
      return true;
    })
    .unsetBold()
    .setParagraph()
    .run();
